export default __webpack_public_path__ + "static/media/group-4.adfc1d73.png";